import { createApiService } from "@/core/api/apiService";
import type {
  CreatePhoneNumberDto,
  PhoneNumberDto,
  UpdatePhoneNumberDto,
} from "../types/phoneNumberTypes";

export function createPhoneNumberApiClient() {
  const api = createApiService("phone-numbers");

  return {
    getByBusinessId: async (businessId: string): Promise<PhoneNumberDto[]> => {
      return api.get<PhoneNumberDto[]>(`/?businessId=${businessId}`);
    },

    create: async (data: CreatePhoneNumberDto): Promise<PhoneNumberDto> => {
      return api.post<PhoneNumberDto>("", data);
    },

    update: async (
      id: string,
      data: UpdatePhoneNumberDto
    ): Promise<PhoneNumberDto> => {
      return api.put<PhoneNumberDto>(`/${id}`, data);
    },

    delete: async (id: string): Promise<{ message: string }> => {
      return api.delete<{ message: string }>(`/${id}`);
    },
  };
}

const phoneNumberApiService = createPhoneNumberApiClient();
export { phoneNumberApiService };
